import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Collapse } from '../../../Collapse';
export function RowTransition(param) {
    let { entering, children } = param;
    const [entered] = useState(entering);
    const [expanded, setExpanded] = useState(!entering);
    useEffect(()=>{
        if (entering) setExpanded(true);
    }, [
        entering
    ]);
    if (!entered) return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
    return /*#__PURE__*/ _jsx(Collapse, {
        in: expanded,
        children: children
    });
}
